import { frontendURL } from '../../../helper/URLHelper';
import ContactsIndex from './pages/ContactsIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'contact_manage'],
};

// Polaris (fase 5.3, Q4): an open contact is a drawer over its list, not a page. The `contacts_edit*` routes keep
// their names and URLs (/contacts/:contactId, …/segments/:segmentId, …/labels/:label) and are children of the list,
// so the same ContactsIndex stays mounted when a contact opens, changes or closes. `contacts_edit_active` is new:
// a contact opened from Active keeps the Active list behind it.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    component: ContactsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_dashboard_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_dashboard_segments_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'contacts_dashboard_labels_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'active',
        name: 'contacts_dashboard_active',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'active/:contactId(\\d+)',
        name: 'contacts_edit_active',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: ':contactId(\\d+)',
        name: 'contacts_edit',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: ':contactId(\\d+)/segments/:segmentId',
        name: 'contacts_edit_segment',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: ':contactId(\\d+)/labels/:label',
        name: 'contacts_edit_label',
        component: ContactsIndex,
        meta: commonMeta,
      },
    ],
  },
];
